import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CampMstApi } from '../api/campMst.api';
import { switchMap, map } from 'rxjs/operators';

import { CampMstData, CampMst } from '../../../interfaces/masters/campMst' ;
@Injectable()
export class CampMstService extends CampMstData {

    constructor(private api: CampMstApi) {
      super();
    }
  
  
    list(url: string): Observable<CampMst[]> {
      
      return this.api.list(url);
    }
  
    getById(url:string): Observable<CampMst>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<CampMst[]> {
      return this.api.add(url,data);
    }
    createFile(url: string, data:any): Observable<any[]> {
      return this.api.addFile(url,data);
    }
    
  searchList(url: string,data:any): Observable<any> {
     
    return this.api.searchList(url,data);
  }
    update(url: string, data:CampMst): Observable<CampMst> {
      debugger;
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  